// extracted by mini-css-extract-plugin
export default {"inputLabel":"Dq3PhB","formButton":"MlqWb4","submitButton":"M3_qnK"};